__turbopack_context__.v({
  "card": "ParagraphFeaturesIcons-module__BmsL9q__card",
  "desc": "ParagraphFeaturesIcons-module__BmsL9q__desc",
  "grid": "ParagraphFeaturesIcons-module__BmsL9q__grid",
  "icon": "ParagraphFeaturesIcons-module__BmsL9q__icon",
  "name": "ParagraphFeaturesIcons-module__BmsL9q__name",
  "section": "ParagraphFeaturesIcons-module__BmsL9q__section",
  "title": "ParagraphFeaturesIcons-module__BmsL9q__title",
});
